import { ChangeDetectorRef, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { TFMService } from 'app/mock-api/tfm.service';
import { FuseCardComponent } from '@fuse/components/card';
import { SearchComponent } from "../../../../layout/common/search-widget/search.component";
import { Router } from '@angular/router';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule, NgFor, NgStyle } from '@angular/common';
import { CountersType01Component } from '../../counter/counters-type01/counters-type01.component';
import { ScrollerSectionType01Component } from "../../scroller-section/scroller_section-type01/scroller_section-type01.component";
import { BannerSectionType01Component } from "../../banner-section/banner_section-type01/banner_section-type01.component";

@Component({
  selector: 'app-leisure-travel-type01',
  standalone: true,
  imports: [CommonModule, MatIconModule, HeadingSectionType01Component, FuseCardComponent, SearchComponent, MatTooltipModule, NgStyle, NgFor, CountersType01Component, ScrollerSectionType01Component, BannerSectionType01Component],
  templateUrl: './leisure-travel-type01.component.html',
  styleUrl: './leisure-travel-type01.component.scss'
})
export class LeisureTravelType01Component {


  public view: any = {
    selectedTab: 'flight',// Default tab;
    metaDataContent: ''
  };

  constructor(private _tfmService: TFMService, private _tfmCartService: TFMCartService, private _cd: ChangeDetectorRef, private _router: Router) {

    this._tfmService.getContentBySection('leisure-travel').then(res => {
      this.view.page = res;
      console.log(res);
      this._tfmService.log(this.view);

      if(this.view.page.content.metaData) {
        this.view.metaDataContent = JSON.parse(this.view.page.content.metaData).general;
        console.log(this.view.metaDataContent);
      }

      if (this.view.page && this.view.page?.content?.images && this.view.page?.content?.images.length > 0) {
        const image = this.view.page?.content?.images[0]; // Access the first image object
        const links = image._links; // Access the _links array

        // Find the link with rel "view"
        const viewLink = links.find((link: any) => link.rel === "view");

        // Get the href if the view link exists
        if (viewLink) {
          this.view.imageHref = viewLink.href;
          this._tfmService.log("Image href:", this.view.imageHref);
        } else {
          console.error("View link not found");
        }
      } else {
        console.error("Images not available");
      }
    });
   }

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);

    });
  }
  selectTab(tab: string) {
    this.view.selectedTab = tab;
    this._cd.detectChanges();
  }

  public tripChanged(tripData) {
    // this._tfmService.log(tripData);

    this.view.trip = tripData;

    // this._tfmCartService.updateTrip(this.view.trip);

    this.redirectToResults();
  }
  public searchChanged(searchData) {
    // this._tfmService.log(searchData);

    this.view.search = searchData;

    this.redirectToResults();
  }
  public resultChanged() {

  }

  public redirectToResults() {
    if (this.view.trip && this.view.search) {
      //Do redirect....
      this._router.navigateByUrl("/search-results", { state: { view: this.view, type: this.view.selectedTab } });
    }
  }
}
